import Cookies from "js-cookie";
import {
  SF_COOKIE_ACCESS_TOKEN,
  SF_COOKIE_AUTH_TOKEN_EXPIRES_IN,
  SF_COOKIE_REFRESH_TOKEN,
  SF_COOKIE_REMEMBER_ME,
  SF_COOKIE_USERNAME
} from "@/modules/auth/persistence/constants";
import config from "@/config";
const cookieSettings = config.get("COOKIE_SETTINGS");

export function persistAuthState(
  username,
  accessToken,
  refreshToken,
  expiresIn
) {
  console.log("[AuthP] Persisting state");
  Cookies.set(SF_COOKIE_USERNAME, username, cookieSettings);
  Cookies.set(SF_COOKIE_ACCESS_TOKEN, accessToken, cookieSettings);
  Cookies.set(SF_COOKIE_REFRESH_TOKEN, refreshToken, cookieSettings);
  Cookies.set(SF_COOKIE_AUTH_TOKEN_EXPIRES_IN, expiresIn, cookieSettings);
  sessionStorage.setItem(SF_COOKIE_ACCESS_TOKEN, accessToken);
}

export function flushAuthState() {
  console.log("[AuthP] Flushing state");
  Cookies.remove(SF_COOKIE_USERNAME, cookieSettings);
  Cookies.remove(SF_COOKIE_ACCESS_TOKEN, cookieSettings);
  Cookies.remove(SF_COOKIE_REFRESH_TOKEN, cookieSettings);
  Cookies.remove(SF_COOKIE_AUTH_TOKEN_EXPIRES_IN, cookieSettings);
  Cookies.remove(SF_COOKIE_REMEMBER_ME, cookieSettings);
  sessionStorage.removeItem(SF_COOKIE_ACCESS_TOKEN);
  sessionStorage.removeItem("X-Session-Key");
}
